import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoize, unlessW, whenW } from '@infl-ts/util-function';
import { Box, FormControl, FormHelperText, styled } from '@mui/material';
import countryRegionData from 'country-region-data';
import * as A from 'fp-ts/Array';
import { identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
import { Translation } from 'react-i18next';
import { AutocompleteFormField, TextFormField } from '../../form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var formatShippingAddressResponse = function formatShippingAddressResponse(shippingAddress) {
  var _shippingAddress$coun;

  return _objectSpread(_objectSpread({}, shippingAddress), {}, {
    country: (_shippingAddress$coun = shippingAddress.country) !== null && _shippingAddress$coun !== void 0 ? _shippingAddress$coun : ''
  });
};
var FormWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiBox-root:last-child {\n    margin-bottom: 0;\n  }\n"])));
var getRegionOptions = memoize(function (currentRegion, t) {
  return function (countryName) {
    return pipe(countryRegionData, A.findFirst(function (c) {
      return c.countryName === countryName;
    }), O.map(function (country) {
      return country.regions;
    }), O.map(A.map(function (r) {
      return r.name;
    })), O.getOrElseW(function () {
      return [];
    }), currentRegion ? unlessW(A.elem(Str.Eq)(currentRegion), A.append(currentRegion)) : identity, whenW(A.isEmpty, A.prepend(t('Not applicable'))));
  };
});

var FormControlWrapper = function FormControlWrapper(_ref) {
  var verticalSpacing = _ref.verticalSpacing,
      children = _ref.children;
  return /*#__PURE__*/_jsx(FormControl, {
    sx: {
      width: 1,
      mb: verticalSpacing
    },
    "data-element": "FormControl",
    "data-component": "FormControlWrapper",
    "data-source-file": "shipping-address-inputs.tsx",
    children: children
  });
};

export var createDefaultShippingAddress = function createDefaultShippingAddress(fullName) {
  return {
    country: null,
    fullName: fullName,
    address: '',
    address2: '',
    city: '',
    region: null,
    postalCode: '',
    phoneNumber: ''
  };
};

var ShippingAddressInputs = function ShippingAddressInputs(_ref2) {
  var _ref2$shippingAddress = _ref2.shippingAddressForm,
      control = _ref2$shippingAddress.control,
      errors = _ref2$shippingAddress.formState.errors,
      setValue = _ref2$shippingAddress.setValue,
      watch = _ref2$shippingAddress.watch,
      _ref2$verticalSpacing = _ref2.verticalSpacing,
      verticalSpacing = _ref2$verticalSpacing === void 0 ? 3 : _ref2$verticalSpacing;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "ShippingAddressInputs",
    "data-source-file": "shipping-address-inputs.tsx",
    children: function children(t) {
      var _errors$shippingAddre, _errors$shippingAddre2, _errors$shippingAddre3, _errors$shippingAddre4, _errors$shippingAddre5, _errors$shippingAddre7, _errors$shippingAddre8;

      return /*#__PURE__*/_jsxs(FormWrapper, {
        id: "shippingAddress",
        children: [/*#__PURE__*/_jsx(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: /*#__PURE__*/_jsx(AutocompleteFormField, {
            control: control,
            name: "shippingAddress.country",
            label: t('Country'),
            required: true,
            options: countryRegionData.map(function (x) {
              return {
                label: x.countryName,
                value: x.countryName
              };
            }),
            error: (_errors$shippingAddre = errors.shippingAddress) === null || _errors$shippingAddre === void 0 ? void 0 : _errors$shippingAddre.country,
            onChange: function onChange() {
              return setValue('shippingAddress.region', null);
            }
          })
        }), /*#__PURE__*/_jsx(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: /*#__PURE__*/_jsx(TextFormField, {
            name: "shippingAddress.fullName",
            control: control,
            required: true,
            label: t('Full name'),
            error: (_errors$shippingAddre2 = errors.shippingAddress) === null || _errors$shippingAddre2 === void 0 ? void 0 : _errors$shippingAddre2.fullName
          })
        }), /*#__PURE__*/_jsxs(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: [/*#__PURE__*/_jsx(TextFormField, {
            name: "shippingAddress.address",
            control: control,
            required: true,
            label: t('Address Line 1'),
            error: (_errors$shippingAddre3 = errors.shippingAddress) === null || _errors$shippingAddre3 === void 0 ? void 0 : _errors$shippingAddre3.address
          }), /*#__PURE__*/_jsx(FormHelperText, {
            children: t('Street address, P.O. box, company name, c/o')
          })]
        }), /*#__PURE__*/_jsxs(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: [/*#__PURE__*/_jsx(TextFormField, {
            name: "shippingAddress.address2",
            control: control,
            label: t('Address Line 2'),
            error: (_errors$shippingAddre4 = errors.shippingAddress) === null || _errors$shippingAddre4 === void 0 ? void 0 : _errors$shippingAddre4.address2
          }), /*#__PURE__*/_jsx(FormHelperText, {
            children: t('Apartment, suite, unit, building, floor, etc.')
          })]
        }), /*#__PURE__*/_jsx(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: /*#__PURE__*/_jsx(TextFormField, {
            name: "shippingAddress.city",
            control: control,
            required: true,
            label: t('City'),
            error: (_errors$shippingAddre5 = errors.shippingAddress) === null || _errors$shippingAddre5 === void 0 ? void 0 : _errors$shippingAddre5.city
          })
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            mb: verticalSpacing,
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row'
            }
          },
          children: [/*#__PURE__*/_jsx(FormControl, {
            sx: {
              width: 1,
              mr: {
                xs: 0,
                md: 2
              },
              mb: {
                xs: verticalSpacing,
                md: 0
              }
            },
            children: pipe(watch('shippingAddress.country') || '', getRegionOptions(watch('shippingAddress.region'), t), function (regions) {
              var _errors$shippingAddre6;

              return /*#__PURE__*/_jsx(AutocompleteFormField, {
                control: control,
                required: true,
                name: "shippingAddress.region",
                label: t('State/Province/Region (if appropriate)'),
                options: regions.map(function (r) {
                  return {
                    label: r,
                    value: r
                  };
                }),
                error: (_errors$shippingAddre6 = errors.shippingAddress) === null || _errors$shippingAddre6 === void 0 ? void 0 : _errors$shippingAddre6.region,
                errorMessage: "Choose a valid region."
              });
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            sx: {
              width: 1
            },
            children: /*#__PURE__*/_jsx(TextFormField, {
              name: "shippingAddress.postalCode",
              control: control,
              required: true,
              label: t('Postal code / ZIP'),
              error: (_errors$shippingAddre7 = errors.shippingAddress) === null || _errors$shippingAddre7 === void 0 ? void 0 : _errors$shippingAddre7.postalCode
            })
          })]
        }), /*#__PURE__*/_jsx(FormControlWrapper, {
          verticalSpacing: verticalSpacing,
          children: /*#__PURE__*/_jsx(TextFormField, {
            name: "shippingAddress.phoneNumber",
            control: control,
            required: true,
            label: t('Phone number'),
            error: (_errors$shippingAddre8 = errors.shippingAddress) === null || _errors$shippingAddre8 === void 0 ? void 0 : _errors$shippingAddre8.phoneNumber
          })
        })]
      });
    }
  });
};

export default ShippingAddressInputs;